import React from "react";
import { Form } from 'antd';

function FormItem(props) {
  const { label, labelExtra, icon: Icon, extra = "", children, value, displayExtra, colon=false, ...rest } = props;

  return (
    <Form.Item
      colon={colon}
      className={`font-medium mb-2 ${extra}`}
      label={
        label ? (
          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-4 h-4 text-purple-600" />}
            <span className="text-sm label-title">{label}</span>
            {labelExtra}
          </div>
        ) : (
          false
        )
      }
      {...rest}
    >
      {children ? (
        children
      ) : (
        <div className={`text-base label-value ${displayExtra}`}>{value}</div>
      )}
    </Form.Item>
  );
}

export default FormItem;

